import { WITH_RX, WITHOUT_RX } from './contants.js';

const isRxRadioSelection = (value)=>value === WITH_RX || value === WITHOUT_RX
;

export { isRxRadioSelection };
//# sourceMappingURL=is-rx-radio-selection.js.map
